import { i18n } from '@/shared/i18n';
import type { BriefTemplateLevel } from '../../model/types';

type BadgeVariant = 'secondary' | 'outline';

export function briefTemplateLevelLabel(level: BriefTemplateLevel): string {
  switch (level) {
    case 'system':
      return i18n.t('knowledge:knowledgeHub.briefTemplateLevelBadge.systemDefault');
    case 'organization':
      return i18n.t('knowledge:knowledgeHub.briefTemplateLevelBadge.organization');
    case 'workspace':
      return i18n.t('knowledge:knowledgeHub.briefTemplateLevelBadge.workspace');
  }
}

/** Outline for the levels the caller's workspace does not own, so its own templates stand out. */
export function briefTemplateLevelVariant(level: BriefTemplateLevel): BadgeVariant {
  return level === 'workspace' ? 'secondary' : 'outline';
}
